import { render, staticRenderFns } from "./CategoriesView.vue?vue&type=template&id=fc6b8706&scoped=true&"
import script from "./CategoriesView.vue?vue&type=script&lang=js&"
export * from "./CategoriesView.vue?vue&type=script&lang=js&"
import style0 from "./CategoriesView.vue?vue&type=style&index=0&id=fc6b8706&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc6b8706",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VContainer})
